<template>
  <div class="forgotpassword-list">
    <Toolbar />

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-account-convert</v-icon>{{$t('administration.user.forgotpasswords')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ForgotPasswordFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.date" slot-scope="{ item }">
                  {{ formatDateTime(item['date'], 'long') }}
                </template>

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ForgotPasswordFilterForm from '../../components/forgotpassword/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'ForgotPasswordList',
  servicePrefix: 'ForgotPassword',
  mixins: [ListMixin],
  components: {
    Toolbar,
    ForgotPasswordFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('administration.user.ipadress'), value: 'ipAdress' },
        { text: this.$t('administration.user.email'), value: 'email' },
        { text: this.$t('administration.user.date'), value: 'date' },
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('forgotpassword', {
      items: 'list'
    }),
    ...mapFields('forgotpassword', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('forgotpassword', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
